import axios from 'axios';

// Use environment variable for API base URL in production, or '/api' for local development (proxied)
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
const API = axios.create({ baseURL: API_BASE_URL });

API.interceptors.request.use(config => {
  const adminToken = localStorage.getItem('adminToken');
  const candidateToken = localStorage.getItem('candidateToken');
  
  // Determine which token to use based on the endpoint
  let token = null;
  if (config.url.includes('/admin')) {
    // Any endpoint with /admin/ is an admin endpoint
    token = adminToken;
  } else if (config.url.startsWith('/candidates') || config.url.startsWith('/questions')) {
    token = candidateToken;
  } else {
    // Fallback: prefer candidate for general endpoints
    token = candidateToken || adminToken;
  }
  
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      // Only remove the token that was actually used
      if (err.config.url.includes('/admin')) {
        localStorage.removeItem('adminToken');
      } else {
        localStorage.removeItem('candidateToken');
      }
    }
    return Promise.reject(err);
  }
);

export default API;
